import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bulkExcludeEmployees } from '../../../services/MoodleService';
import { moodleQueryKeys } from '../all-query-keys';

export const useBulkExcludeEmployees = (onSuccess) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: ({ courseConfigId, payload }) =>
      bulkExcludeEmployees(courseConfigId, payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: [moodleQueryKeys.courseExclusions],
      });
      onSuccess?.(...args);
    },
  });

  return { mutate, isPending };
};
